import {Pipe, PipeTransform} from '@angular/core';
import {WorkflowTransition} from '@nh/angular-tses';
import {WorkflowStates} from '../../workflow/workflow-states';
import {WorkflowAction} from '../types';

@Pipe({
  name: 'dasWorkflowToAction'
})
export class DasWorkflowToActionPipe implements PipeTransform {
  constructor() {}

  /**
   * Transforms a workflow state name into a corresponding workflow action.
   *
   * @param transition {WorkflowTransition}   Workflow state name
   * @returns          {WorkflowAction}       Workflow action
   */
  public transform(transition: WorkflowTransition): WorkflowAction {
    switch (transition.to) {
      case WorkflowStates.REJECTED: {
        return WorkflowAction.REJECT;
      }
      case WorkflowStates.WITHDRAWN: {
        return WorkflowAction.WITHDRAW;
      }
      case WorkflowStates.REWORK_REQUIRED: {
        return WorkflowAction.REWORK_REQUIRED;
      }
      case WorkflowStates.PM_APPRAISAL_REWORK: {
        return WorkflowAction.PM_APPRAISAL_REWORK;
      }
      case WorkflowStates.SPECIALIST_SUBMISSION_POINT_REWORK: {
        return WorkflowAction.SPECIALIST_SUBMISSION_POINT_REWORK;
      }
      default: {
        return WorkflowAction.TRANSITION_CRITICAL_PATH;
      }
    }
  }
}
